function Infobox({className, children}) {
	// compute class name
	let classList = ["info-box"];

	if (typeof className === "string") {
		classList.push(className);
	}

	return (
		<div className={classList.join(" ")}>{children}</div>
	);
}

module.exports = Infobox;


// WEBPACK FOOTER //
// ./resources/js/components/mixins/Infobox.js